import { PersonCardComponent } from './PersonCard';
export default PersonCardComponent;
